// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__Yzl36","divider":"styles_divider__Z1sPy","buttons":"styles_buttons__7BY7n"};